import { render, staticRenderFns } from "./setCardPosition.vue?vue&type=template&id=1f2e1750&scoped=true&"
import script from "./setCardPosition.vue?vue&type=script&lang=js&"
export * from "./setCardPosition.vue?vue&type=script&lang=js&"
import style0 from "./setCardPosition.vue?vue&type=style&index=0&id=1f2e1750&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2e1750",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\kzt\\project_vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f2e1750')) {
      api.createRecord('1f2e1750', component.options)
    } else {
      api.reload('1f2e1750', component.options)
    }
    module.hot.accept("./setCardPosition.vue?vue&type=template&id=1f2e1750&scoped=true&", function () {
      api.rerender('1f2e1750', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/web/isv/kingdee/hr/wtcsetcardposition/components/setCardPosition.vue"
export default component.exports